<template>
  <v-dialog v-model="getModalPesquisarContato" fullscreen>
    <v-card>
      <v-card-title>
        Pesquisar Contato
        <v-spacer></v-spacer>
        <v-btn icon @click="setModalPesquisarContato(false)" float-right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-title>
        <v-spacer></v-spacer>
        Contatos: {{ getContatos.total }} -
        <v-pagination
          outlined
          total-visible="7"
          v-model="getContatos.current_page"
          :length="getContatos.last_page"
          @input="visualizarPagina($event)"
        ></v-pagination>
        <!-- <v-layout row wrap>
          <v-row justify="center"> </v-row>

          <v-flex xs12 md10>
            <span class="float-right title mr-10 ml-1">
              <h5>
                Página: {{ getContatos.current_page }} de
                {{ getContatos.last_page }}
              </h5></span
            >
            <span class="float-right title mr-1 ml-1">
              <h5>Contatos: {{ getContatos.total }} -</h5>
            </span>
          </v-flex>
          <v-flex xs12 md2>
            <v-icon
              class="mr-1 ml-1"
              v-if="getContatos.current_page > 1"
              @click="visualizarPagina(1)"
            >
              mdi-arrow-collapse-left</v-icon
            >
            <v-icon
              class="mr-1 ml-1"
              v-if="getContatos.current_page > 1"
              @click="visualizarPagina(getContatos.current_page - 1)"
              >keyboard_arrow_left</v-icon
            >
            <v-icon
              class="mr-1 ml-1"
              v-if="getContatos.current_page < getContatos.last_page"
              @click="visualizarPagina(getContatos.current_page + 1)"
              >keyboard_arrow_right</v-icon
            >
            <v-icon
              class="mr-1 ml-1"
              v-if="getContatos.current_page < getContatos.last_page"
              @click="visualizarPagina(getContatos.last_page)"
              >mdi-arrow-collapse-right</v-icon
            >
          </v-flex>
        </v-layout> -->
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.id"
                    autocomplete="new-id"
                    outlined
                    dense
                    label="Código"
                    class="mt-2"
                    @input="debouncePesquisarContato()"
                    type="number"
                    @keyup.enter="
                      selecionarContato(
                        getContatos.data[indexLinhaSelecionadaTabela]
                      )
                    "
                  ></v-text-field>
                </th>
                <th>
                  <v-text-field
                    v-model="dataPagina.nome"
                    autocomplete="new-nome"
                    outlined
                    dense
                    label="Nome"
                    class="mt-2"
                    @input="debouncePesquisarContato()"
                    id="inputValorPesquisaContato"
                    @keyup.enter="
                      selecionarContato(
                        getContatos.data[indexLinhaSelecionadaTabela]
                      )
                    "
                  ></v-text-field>
                </th>
                <th width="12%">
                  <v-text-field
                    v-model="dataPagina.cpf_cnpj"
                    autocomplete="new-cpf_cnpj"
                    outlined
                    dense
                    label="CPF/CNPJ"
                    class="mt-2"
                    v-mask="['##.###.###/####-##', '###.###.###-##']"
                    @input="debouncePesquisarContato()"
                    @keyup.enter="
                      selecionarContato(
                        getContatos.data[indexLinhaSelecionadaTabela]
                      )
                    "
                  ></v-text-field>
                </th>
                <th width="12%">
                  <v-select
                    :items="getTiposContatos"
                    v-model="dataPagina.tipo"
                    label="Tipo"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncePesquisarContato()"
                    @keyup.enter="
                      selecionarContato(
                        getContatos.data[indexLinhaSelecionadaTabela]
                      )
                    "
                  ></v-select>
                </th>
                <th width="12%">
                  <v-text-field
                    v-model="dataPagina.cidade"
                    autocomplete="new-cidade"
                    outlined
                    dense
                    label="Cidade"
                    class="mt-2"
                    @input="debouncePesquisarContato()"
                    @keyup.enter="
                      selecionarContato(
                        getContatos.data[indexLinhaSelecionadaTabela]
                      )
                    "
                  ></v-text-field>
                </th>
                <!-- <th>
                  <v-text-field v-model="dataPagina.telefone" autocomplete="new-telefone" label outlined dense label="Telefone" class="mt-2" v-mask="'(##) ####-####'" @input="debouncePesquisarContato()" @keyup.enter="selecionarContato(getContatos.data[indexLinhaSelecionadaTabela])"></v-text-field>
                </th> -->
                <th width="10%">
                  <v-select
                    outlined
                    dense
                    :items="resultadosPorPagina"
                    item-value="value"
                    item-text="label"
                    v-model="limitePorPagina"
                    label="Exibir"
                    @change="visualizarPagina(getContatos.current_page)"
                    class="mt-2"
                  ></v-select>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, key) in getContatos.data"
                :key="item.id"
                @click="selecionarContato(item)"
                :class="
                  indexLinhaSelecionadaTabela == key ? 'linhaSelecionada' : ''
                "
              >
                <td>{{ item.id }}</td>
                <td>{{ item.nome }}</td>
                <td>{{ item.cpf_cnpj }}</td>
                <td>{{ item.tipo }}</td>
                <td>{{ item.cidade }}/{{ item.uf }}</td>
                <!-- <td>  
                  <span v-if="item.telefone">{{ item.telefone }}</span>
                  <span v-if="item.celular1"> / {{ item.celular1 }}</span>
                </td> -->
                <td>
                  <v-btn
                    color="primary"
                    x-small
                    @click="selecionarContato(i)"
                    outlined
                    >Adicionar
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <h3>Contatos: {{ getContatos.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getContatos.current_page"
          :length="getContatos.last_page"
          @input="visualizarPagina($event)"
        ></v-pagination>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
var _ = require("lodash");
export default {
  data() {
    return {
      pesquisando: false,
      limitePorPagina: 20,
      dataPagina: {
        pagina: 1,
        id: "",
        nome: "",
        tipo: "",
        cpf_cnpj: "",
        cidade: "",
        telefone: "",
        limit: 20,
      },
      valorPesquisa: "",
      campoPesquisa: "nome",
      indexLinhaSelecionadaTabela: 0,
      resultadosPorPagina: [
        {
          label: "10",
          value: 10,
        },
        {
          label: "20",
          value: 20,
        },
        {
          label: "30",
          value: 30,
        },
        {
          label: "40",
          value: 40,
        },
        {
          label: "50",
          value: 50,
        },
      ],
      camposPesquisa: [
        {
          label: "Nome",
          value: "nome",
        },
        {
          label: "CPF/CNPJ",
          value: "cpf_cnpj",
        },
        {
          label: "Código",
          value: "id",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getModalPesquisarContato",
      "getContatos",
      "getOverlay",
      "getTiposContatos",
    ]),
  },
  watch: {
    valorPesquisa() {
      this.debouncePesquisarContato();
    },
    getModalPesquisarContato() {
      if (this.getModalPesquisarContato) {
        this.dataPagina.id = "";
        this.dataPagina.nome = "";
        this.dataPagina.tipo = "";
        this.dataPagina.cpf_cnpj = "";
        this.dataPagina.cidade = "";
        this.dataPagina.telefone = "";
        this.dataPagina.pagina = 1;
        this.dataPagina.limit = 20;
         setTimeout(() => {
          this.pesquisarContatos();
        }, 100);

        setTimeout(() => {
          this.focusValorPesquisa();
        }, 100);
      }
    },
  },
  methods: {
    ...mapActions([
      "setModalPesquisarContato",
      "visualizarPaginaContato",
      "listarContatos",
    ]),
    selecionarContato(contato) {
      this.$store.commit("setContato", { ...contato });
      this.setModalPesquisarContato(false);
    },
    visualizarPagina(pagina) {
      this.dataPagina.page = pagina;
      this.dataPagina.path = this.getContatos.path;
      this.dataPagina.limite = this.limitePorPagina;
      this.listarContatos(this.dataPagina);
    },

    pesquisarContatos() {
      this.dataPagina.pagina = 1;
      this.dataPagina.path = this.getContatos.path;
      this.dataPagina.limite = this.limitePorPagina;
      this.listarContatos(this.dataPagina);
    },
    focusValorPesquisa() {
      document.getElementById("inputValorPesquisaContato").focus();
    },
    keyUp(e) {
      if (!e) e = window.event;
      let keyCode = e.keyCode || e.which;
      if (keyCode == 40) e.preventDefault();
      if (keyCode == 38) e.preventDefault();

      if (keyCode == 40) {
        if (
          this.indexLinhaSelecionadaTabela <
          this.getContatos.data.length - 1
        ) {
          this.indexLinhaSelecionadaTabela++;
        }
      }

      if (keyCode == 38) {
        if (this.indexLinhaSelecionadaTabela >= 1) {
          this.indexLinhaSelecionadaTabela -= 1;
        }
      }
    },
  },
  created() {
    document.addEventListener("keydown", this.keyUp);
    this.debouncePesquisarContato = _.debounce(this.pesquisarContatos, 300);
  },
};
</script>
